import { useRefreshOrders } from '@src/orders/hooks/useRefreshOrders';
import type { ProcessWithJurisdictionPermitSchema } from '@src/permits/completePermit/fields/ProcessWithJurisdictionPermitFields';
import { PermitApplicationClient } from '@src/permits/services/PermitApplicationClient';
import { useMutation } from '@tanstack/react-query';
import type * as yup from 'yup';

interface Props {
  permitApplicationId: string;
  onSuccess: () => void;
  onError?: () => void;
}

export const useSubmitPermit = ({ permitApplicationId, onSuccess }: Props) => {
  const { refreshOrders } = useRefreshOrders();

  const { mutateAsync: submitPermit } = useMutation({
    mutationFn: async ({
      confirmationNumber,
    }: yup.InferType<typeof ProcessWithJurisdictionPermitSchema>) => {
      await PermitApplicationClient.submit({
        permitApplicationId,
        confirmationNumber,
      });
    },
    onSuccess: () => {
      onSuccess();
      refreshOrders();
    },
  });

  return {
    submitPermit,
  };
};
